export const adminEditor = {
    "& img": {
        width:'100%'
    },

    "& .admin-editor-ident" : {
        display:'block',
        paddingLeft:'25px'
    }
}